import { ConfigState } from 'store/config/types';
import { RootState } from 'store/reducer';

export const configSelector = (state: RootState): ConfigState => state.config;
